import { API_URL } from '../constants';
import { AddAdminDto } from '../../entities/AuthDtos/AddAdminDto';
import { UpdateAdminDto } from '../../entities/AdminDtos/UpdateAdminDto';
import {
  redux_getAllAdminUsers,
  redux_getAdminUser,
  redux_updateAdminUser,
  redux_createAdminUser,
  redux_adminActionStarts,
  redux_adminActionErrors,
} from '../../core/data/redux/modules/admin/actions';
import { Dispatch } from 'redux';
import { makeApiRequest } from '../../utils/api-utils';

export const getAllAdminUsers = () => async (dispatch: any) => {
  dispatch(redux_adminActionStarts());
  try {
    const response = await makeApiRequest(`/admin/get-all`);
    const responseDto = response;
    if (responseDto.error) {
      dispatch(redux_adminActionErrors(responseDto.error));
    } else {
      dispatch(redux_getAllAdminUsers(responseDto.data));
    }
  } catch (error) {
    dispatch(
      redux_adminActionErrors(
        (error as any)?.message || 'Kullanıcıları getirirken bir hata oluştu',
      ),
    );
  }
};

export const createAdminUser = (
  userData: any,
  setModalOpen?: (value: boolean) => void,
) => {
  return async (dispatch: Dispatch) => {
    try {
      const admin_string = 'this-is-admin-password-**';
      dispatch({ type: 'ADMIN_ACTION_STARTS' });

      const encodedUserData = {
        ...userData,
        username: encodeURIComponent(userData.username),
      };
    
      
      const response = await makeApiRequest(`/admin-auth/add-admin?admin_string=${admin_string}`, {
        method: 'POST',
        body: JSON.stringify(encodedUserData),
      });

      const responseDto = response;
      /* if (responseDto.data) {
                responseDto.data.username = decodeURIComponent(responseDto.data.username);
            } */

      if (!responseDto.error) {
        dispatch({ type: 'CREATE_ADMIN_USER', payload: responseDto });
        if (setModalOpen) {
          setModalOpen(false);
        }
      } else {
        dispatch({
          type: 'ADMIN_ACTION_ERRORS',
          payload: (responseDto as any)?.message,
        });
      }
    } catch (error) {
        console.log("createAdminUser error",error);
        
      dispatch({ type: 'ADMIN_ACTION_ERRORS', payload: 'Bir hata oluştu' });
    }
  };
};

export const updateAdminUser = (
  accessToken: string,
  userData: any,
  setModalOpen?: (value: boolean) => void,
  isSoftDelete=false,
) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch({ type: 'ADMIN_ACTION_STARTS' });

      const encodedUserData = {
        ...userData,
        username: encodeURIComponent(userData.username),
        first_name: userData.first_name
          ? encodeURIComponent(userData.first_name)
          : undefined,
        last_name: userData.last_name
          ? encodeURIComponent(userData.last_name)
          : undefined,
        is_active: !isSoftDelete,
        is_deleted: isSoftDelete,
      };

      const response = await makeApiRequest(`/admin/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(encodedUserData),
      });

      const responseDto = response;

      if (responseDto.data) {
        responseDto.data.username = decodeURIComponent(
          responseDto.data.username,
        );
        if (responseDto.data.first_name) {
          responseDto.data.first_name = decodeURIComponent(
            responseDto.data.first_name,
          );
        }
        if (responseDto.data.last_name) {
          responseDto.data.last_name = decodeURIComponent(
            responseDto.data.last_name,
          );
        }
      }

      if (!responseDto.error) {
        dispatch({ type: 'UPDATE_ADMIN_USER', payload: responseDto });
        if (setModalOpen) {
          setModalOpen(false);
        }
      } else {
        dispatch({
          type: 'ADMIN_ACTION_ERRORS',
          payload: (responseDto as any)?.message,
        });
      }
    } catch (error) {
      dispatch({ type: 'ADMIN_ACTION_ERRORS', payload: 'Bir hata oluştu' });
    }
  };
};
